<template>
  <div class="Div">
    <!-- <header1></header1> -->
    <!-- 第一屏 -->
    <div
      class="InitialScreen"
      :style="'height:'+height+''"
    >
      <img
        class="OneBackImg"
        :src="ScreenImg"
        alt=""
      >
      <div class="sb">
        <img
          class="sbImg"
          src="../../../static/image/shubiao.png"
          alt=""
          srcset=""
        >
        <span class="sp1"></span>
        <span class="span"></span>
      </div>
    </div>
    <!-- 新闻资讯 -->
    <section class="section1">
      <div class="stitle">
        <p class="p">{{newsList.classInfo.type_name_cn}}</p>
        <p class="p">{{newsList.classInfo.type_name_en}}</p>
        <img
          src="../../../static/image/zhuangshi.png"
          alt=""
        >
      </div>
      <div class="content">
        <img
          class="newsImg"
          :src="newsList.banner"
          alt=""
        >
        <ul class="news">
          <li
            class="li"
            v-for="(item,i) of newsList.data"
            :key="i"
            @click="detailClick(item)"
          >
            <div class="date">
              <img
                class="newImg"
                :src="item.article_img"
                alt=""
              >
            </div>
            <div
              class="ellipsis2 headline"
              :title="item.article_title_cn"
            >
              {{item.article_title_cn}}

            </div>
          </li>
        </ul>

      </div>
      <el-button
        class="more"
        @click="moreClick(newsList.classInfo.article_type_id)"
      >{{newsList.seeMore}}</el-button>
    </section>
    <!-- 校园视频 -->
    <section class="section2">
      <div class="stitle">
        <p class="p">{{videoList.title.title_cn}}</p>
        <p class="p">{{videoList.title.title_en}}</p>
        <img
          src="../../../static/image/zhuangshi.png"
          alt=""
        >
      </div>
      <div class="content" v-if="videoList.list.length>0">
        <div
          class="left"
          @click="videoDetail(videoList.list[0])"
        >
          <img
            :src="videoList.list[0].video_img"
            alt=""
            class="backImg"
          >
          <p
            class="ptitle ellipsis"
            :title="videoList.list[0].video_title_cn"
          >
            {{videoList.list[0].video_title_cn}}
          </p>
        </div>
        <div class="right">
          <div
            class="rightcont"
            v-for="(item,i) of videoList.list.slice(1)"
            :key="i"
            @click="videoDetail(item)"
          >
            <img
              :src="item.video_img"
              alt=""
              class="backImg"
            >
            <p
              class="ptitle ellipsis"
              :title="item.video_title_cn"
            >
              {{item.video_title_cn}}
            </p>
          </div>
        </div>
      </div>
      <el-button
        class="more"
        @click="moreVideo()"
      >{{newsList.seeMore}}</el-button>
    </section>
    <!-- 校园图库 -->
    <section class="section3">
      <div class="stitle">
        <p class="p">{{footBanner.title.title_cn}}</p>
        <p class="p">{{footBanner.title.title_en}}</p>
        <img
          src="../../../static/image/zhuangshi.png"
          alt=""
        >
      </div>

      <swiper
        ref="mySwiper"
        :options="swiperOption"
        class="myswiper"
      >
        <swiper-slide
          class="swiperslide"
          v-for="(item,i) of footBanner.list"
          :key='i'
        >
          <!-- @click="swiperClick(item)" -->
          <div
            class="swiperDiv"
            @mouseenter="onEnter"
            @mouseleave="onLeave"
          >
            <div class="divImg">
              <img
                class=""
                :src="item.cover_img"
                alt=""
                :data-pages='i'
              >
              <p
                class="ptitle ellipsis"
                :title="item.album_title_cn"
                :data-pages='i'
              >
                {{item.album_title_cn}}
              </p>
            </div>
          </div>
        </swiper-slide>
      </swiper>
      <el-button
        class="more"
        @click="moreGallery()"
      >查看更多</el-button>
    </section>
  </div>
</template>
<script>
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
// import header1 from "../../layout/AppHeader";
import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import { GalleryGetList } from "@/api/Album";
import { news, campusVideo } from "@/api/CampusNews";
import { getBanner } from "../../api/home";
import { VideoGetList } from "../../api/Overview";
export default {
  name: "SchoolNews",
  data() {
    let _that = this;
    return {
      ScreenImg: "",
      height: "", //高度
      newsList: { classInfo: {}, data: [{ article_img: "" }] }, //头条新闻
      swiperOption: {
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: false
        },
        centeredSlides: true,
        effect: "coverflow",
        slidesPerView: 3,
        // centeredSlides:true,
        spaceBetween: 30,
        coverflowEffect: {
          rotate: 0,
          stretch: "-4%",
          depth: 100,
          modifier: 2,
          slideShadows: false
        },
        // setWrapperSize: true,
        preventClicksPropagation: true,
        loop: true,
        observer: true,
        observeParents: true,
        on: {
          click: function(event) {
            // console.log(
            //   "你点了Swiper",
            //   this.realIndex,
            //   event.target.getAttribute('data-pages')

            // );
            var index = event.target.getAttribute('data-pages');
            var laber = [0, 9, 10, 18];
            var laPath = ["/", "/SchoolNews", "/SchoolNews"];
            var routeData = _that.$router.resolve({
              path: "/GalleryDetail",
              query: {
                laber: JSON.stringify(laber),
                id: _that.footBanner.list[index].album_id,
                laPath: JSON.stringify(laPath)
              }
            });
            window.open(routeData.href, "_blank");
          }
        }
      }, //swiper参数
      footBanner: { title: {}, list: {} }, //相册
      videoList: { title: {}, list: [{ video_img: "" }] } //校园视频
    };
  },

  computed: {
    ...mapState("user", ["headerHeight"]),
    swiper() {
      return this.$refs.mySwiper.$swiper;
    }
  },
  components: {
    Swiper,
    SwiperSlide
  },
  directives: {
    swiper: directive
  },
  methods: {
    // 监听浏览器高度宽度变化
    getHeight() {
      //   console.log(this.headerHeight, "dfsf");
      this.height = window.innerHeight - this.headerHeight + "px";
    },
    // 校园图库详情
    swiperClick(item) {
      // console.log(i);
      // this.swiper.autoplay.start();
      var laber = [0, 9, 10, 18];
      var laPath = ["/", "/SchoolNews", "/SchoolNews"];
      var routeData = this.$router.resolve({
        path: "/GalleryDetail",
        query: {
          laber: JSON.stringify(laber),
          id: item.album_id,
          laPath: JSON.stringify(laPath)
        }
      });
      window.open(routeData.href, "_blank");
    },
    // 鼠标移入暂停循环轮播
    onEnter() {
      if (this.swiper.autoplay) {
        this.swiper.autoplay.stop();
      }
    },
    onLeave() {
      // console.log('dssd',this.swiper.autoplay)
      if (this.swiper.autoplay) {
        this.swiper.autoplay.start();
      }
    },
    //新闻详情
    detailClick(item) {
      var laber = [0, 9, 42, 18];
      var laPath = ["/", "/SchoolNews", "/SchoolNews"];
      var routeData = this.$router.resolve({
        path: "/NewsDetails",
        query: {
          laber: JSON.stringify(laber),
          id: item.article_id,
          laPath: JSON.stringify(laPath)
        }
      });
      window.open(routeData.href, "_blank");
    },
    // 新闻列表
    moreClick(item) {
      var laber = [0, 9, 42, 17];
      var laPath = ["/", "/SchoolNews", "/SchoolNews"];
      this.$router.push({
        path: "/NewsList",
        query: { laber: JSON.stringify(laber), laPath: JSON.stringify(laPath),uid:item }
      });
    },
    // 校园视频列表
    moreVideo(id) {
      var laber = [0, 9, 11, 17];
      var laPath = ["/", "/SchoolNews", "/SchoolNews"];
      this.$router.push({
        path: "/VideoLists",
        query: {
          laber: JSON.stringify(laber),
          laPath: JSON.stringify(laPath)
          // uid: id
        }
      });
    },
    // 校园图库列表
    moreGallery() {
      var laber = [0, 9, 10, 17];
      var laPath = ["/", "/SchoolNews", "/SchoolNews"];
      this.$router.push({
        path: "/GalleryLists",
        query: { laber: JSON.stringify(laber), laPath: JSON.stringify(laPath) }
      });
    },
    // 校园视频详情 VideoDetail
    videoDetail(item) {
      var laber = [0, 9, 11, 29];
      var laPath = ["/", "/SchoolNews", "/SchoolNews"];
      var routeData = this.$router.resolve({
        path: "/VideoDetail",
        query: {
          laber: JSON.stringify(laber),
          id: item.video_id,
          laPath: JSON.stringify(laPath)
        }
      });
      window.open(routeData.href, "_blank");
    },
    // 获取相册内容
    GalleryList() {
      GalleryGetList({
        address: 2,
        per_page: 5
      }).then(res => {
        // console.log(res.data);
        this.footBanner = res.data;
        this.swiper.slideTo(2);
      });
    },
    // 新闻列表
    ArticlegetLists() {
      news({
        limit: 3
      }).then(res => {
        // console.log(res.data);
        this.newsList = res.data;
      });
    }
  },
  created() {
    // 第一屏banner
    getBanner({
      address: 13
    }).then(res => {
      this.ScreenImg = res.data.banner_img;
    });
    // 校园视频
    VideoGetList({
      per_page: 3,
      page: 1
    }).then(res => {
      // console.log(res.data);
      this.videoList = res.data;
    });
  },
  mounted() {
    window.addEventListener("resize", this.getHeight);
    this.getHeight();
    this.GalleryList();
    this.ArticlegetLists();
  },
  destroyed() {
    window.removeEventListener("resize", this.getHeight);
  }
};
</script>
<style lang="scss" scoped>
@import "../../assets/custom/common.scss";
.InitialScreen {
  position: relative;
  width: 100%;
  //   height: 79.5vh;
  background-size: cover;
  padding-top: 0.1px;
  &::before {
    display: block;
    position: absolute;
    content: "";
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.4);
    z-index: 1;
    top: 0;
    left: 0;
  }
  .overview {
    position: relative;
    margin-left: 16.1%;
    margin-top: 5%;
    z-index: 1;
    text-align: left;
    .title {
      position: relative;
      font-size: px2Rem(80px);
      // font-family: "STXinwei";
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      cursor: pointer;
      span {
        vertical-align: middle;
      }
      &::before {
        display: block;
        position: absolute;
        content: "";
        width: px2Rem(100px);
        height: px2Rem(4px);
        bottom: px2Rem(-30px);
        left: px2Rem(10px);
        border-radius: 2px;
        background-color: #fff;
      }
    }
    .overImg {
      width: px2Rem(38px);
      height: px2Rem(38px);
      margin-left: px2Rem(15px);
    }
    .caption {
      width: px2Rem(707px);
      margin-top: px2Rem(70px);
      font-size: px2Rem(28px);
      // font-family: STXinwei;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      line-height: px2Rem(35px);
    }
    .btn {
      padding: px2Rem(19px) px2Rem(68px);
      margin-top: px2Rem(60px);
      border: 2px solid rgba(255, 255, 255, 1);
      border-radius: 4px;
      font-size: px2Rem(24px);
      // font-family: STXinwei;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      background: rgba(0, 0, 0, 0);
      transition: 0.3s;
      &:hover {
        background: rgba(255, 255, 255, 0.3);
      }
    }
  }
}

.section1 {
  width: px2Rem(1300px);
  margin: px2Rem(60px) auto;
  .content {
    margin-top: px2Rem(35px);
  }
  .news {
    display: inline-block;
    // margin-top: px2Rem(35px);
    margin-left: px2Rem(25px);
    font-size: 0;
    vertical-align: top;
    .li {
      //   width: px2Rem(374px);
      //   height: px2Rem(90px);
      padding: px2Rem(10px) px2Rem(10px) px2Rem(10px) px2Rem(5px);

      margin-bottom: px2Rem(20px);
      background: rgba(255, 255, 255, 1);
      // border: 1px #fff solid;
      transition: 0.3s;
      cursor: pointer;
      &:nth-of-type(3n) {
        margin-right: 0px;
        margin-bottom: 0px;
      }
      &:hover {
        // border: 1px #e9e9e9 solid;
        box-shadow: 0px 0px 5px 2px #e9e9e9;
        .headline {
          color: #1c3278;
        }
      }
      .date {
        display: inline-block;
        width: px2Rem(136px);
        height: px2Rem(100px);
        // padding: px2Rem(5px) px2Rem(8px);
        // background: rgba(226, 187, 129, 1);
        border-radius: 4px;
        text-align: center;
        color: rgba(255, 255, 255, 1);
        font-size: 0;
        vertical-align: middle;
        .newImg {
          width: 100%;
          height: 100%;
          border-radius: 4px;
        }
      }
      .headline {
        display: inline-block;
        width: px2Rem(475px);
        height: px2Rem(57px);
        margin-left: px2Rem(10px);
        // padding:px2Rem(17px) 0 ;
        font-size: px2Rem(28px);
        // font-family: STXinwei;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        vertical-align: middle;
      }
    }
  }
  .newsImg {
    position: relative;
    top: px2Rem(10px);
    display: inline-block;
    width: px2Rem(630px);
    height: px2Rem(380px);
    // border-radius: 8px;
    cursor: pointer;
  }
}
.more {
  display: block;
  margin: px2Rem(40px) auto 0px;
  padding: px2Rem(20px) px2Rem(68);
  border: 1px solid rgba(28, 50, 120, 1);
  border-radius: 4px;
  font-size: px2Rem(24px);
  // font-family: STXinwei;
  font-weight: 400;
  color: rgba(28, 50, 120, 1);
  transition: 0.3s;
  &:hover {
    background: rgba(28, 50, 120, 0.5);
    color: #fff;
    border: 1px solid #fff;
  }
}

.stitle {
  text-align: center;
  .p {
    font-size: px2Rem(50px);
    // font-family: STXinwei;
    font-weight: bold;
    color: rgba(28, 50, 120, 1);
    &:nth-of-type(2) {
      padding: px2Rem(15px) 0 px2Rem(29px);
      font-size: px2Rem(24px);
      font-family: Arial;
      font-weight: 400;
      color: rgba(205, 205, 205, 1);
    }
  }
  > img {
    width: px2Rem(28);
    height: px2Rem(28);
  }
}
.section2 {
  padding: px2Rem(60px) 0;
  background: #f5f5f5;
  .content {
    width: px2Rem(1300px);
    margin: auto;
    margin-top: px2Rem(35px);
    font-size: 0;
    .left {
      display: inline-block;
      position: relative;
      width: px2Rem(858px);
      height: px2Rem(520px);
      margin-right: px2Rem(18px);
      cursor: pointer;
      vertical-align: top;
      overflow: hidden;
      &:hover {
        .backImg {
          transform: scale(1.1);
        }
        .ptitle {
          // color: #1c3278;
        }
      }
    }
    .backImg {
      position: absolute;
      width: 100%;
      height: 100%;
      transition: 0.5s;
    }
    .ptitle {
      position: absolute;
      width: px2Rem(818px);
      padding: px2Rem(19px) px2Rem(20px);
      bottom: 0;
      background: rgba(0, 0, 0, 0.3);
      font-size: px2Rem(34px);
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      transition: 1s;
    }
    .right {
      display: inline-block;
      .rightcont {
        position: relative;
        width: px2Rem(422px);
        height: px2Rem(250px);
        cursor: pointer;
        overflow: hidden;
        &:hover {
          .backImg {
            transform: scale(1.1);
          }
          .ptitle {
            // color: #1c3278;
          }
        }
        &:first-of-type {
          margin-bottom: px2Rem(20px);
        }
        .ptitle {
          position: absolute;
          width: px2Rem(382px);
          padding: px2Rem(22px) px2Rem(20px);
          font-size: px2Rem(28px);
        }
      }
    }
  }
  .btn {
    display: block;
    width: px2Rem(220px);
    height: px2Rem(60px);
    margin: auto;
    margin-top: px2Rem(40px);
    background: rgba(0, 0, 0, 0);
    border: 1px solid rgba(28, 50, 120, 1);
    border-radius: 4px;
    font-size: px2Rem(24px);
    font-weight: 400;
    color: rgba(28, 50, 120, 1);
    transition: 0.3s;
    &:hover {
      background: #ecf5ff;
    }
  }
}
.section3 {
  padding: px2Rem(60px) 0;
  .swiperslide {
    cursor: pointer;

    .divImg {
      position: relative;
      width: 100%;
      height: 100%;
      img {
        width: 100%;
        height: 100%;
      }
      .ptitle {
        position: absolute;
        width: 100%;
        // height: px2Rem(30px);
        padding: px2Rem(19px) px2Rem(0px);
        bottom: 5px;
        background: rgba(0, 0, 0, 0.3);
        font-size: px2Rem(34px);
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        transition: 1s;
      }
    }
  }
  .myswiper {
    margin-top: px2Rem(35px);
  }
  .btn {
    display: block;
    width: px2Rem(220px);
    height: px2Rem(60px);
    margin: auto;
    margin-top: px2Rem(40px);
    background: rgba(0, 0, 0, 0);
    border: 1px solid rgba(28, 50, 120, 1);
    border-radius: 4px;
    font-size: px2Rem(24px);

    font-weight: 400;
    color: rgba(28, 50, 120, 1);
    transition: 0.3s;
    &:hover {
      background: #ecf5ff;
    }
  }
}
.Div {
  font-family: "STXinwei";
  button {
    font-family: "STXinwei";
  }
}
.title {
  z-index: 1;
}
</style>


// WEBPACK FOOTER //
// src/views/SchoolNews/Index.vue